module.exports = __webpack_public_path__ + "img/regulation-3.b1d48c70.svg";